import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout-progress-bar d-flex justify-content-center flex-wrap" }
const _hoisted_2 = { class: "active" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Shopping Cart")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Checkout")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", { class: "disabled" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "javascript:;" }, "Order Complete")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'Cart' } }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createElementVNode("li", null, [
      _createVNode(_component_router_link, { to: { name: 'Checkout' } }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ]),
    _hoisted_5
  ]))
}